import { Toggle } from '@/components/Elements/Toggle/Toggle';
import { FeatureKeys } from '@/config';
import { TranslationInfo } from '@/features/analyze/types';
import { CanAccess } from '@/providers/CanAccess';
import { useTranslation } from 'react-i18next';

type TranslateSearchTextProps = {
  isEnabled: boolean | undefined;
  onToggle: (isEnabled: boolean) => void;
  translationInfo?: TranslationInfo | null;
};

export const TranslateSearchTextControls = ({
  isEnabled,
  onToggle,
  translationInfo,
}: TranslateSearchTextProps) => {
  const { t } = useTranslation();

  return (
    <CanAccess featureKey={FeatureKeys.searchTranslation}>
      <div>
        <div className="flex items-center gap-x-6 text-sm">
          <div className="flex items-center gap-x-1">
            <span>{t('検索ワード英語翻訳')}</span>
            <Toggle checked={isEnabled} onChange={onToggle} size="sm" />
          </div>
          {translationInfo && (
            <div className="flex items-center gap-x-4 text-gray-600">
              <div>
                {t('入力ワード')}: {translationInfo.originalKeyword}
              </div>
              <div>
                {t('検索ワード')}: {translationInfo.translatedKeyword}
              </div>
            </div>
          )}
        </div>
      </div>
    </CanAccess>
  );
};
